/**
 * Branding component messages
 * Used in: src/features/FormBuilder/components/Branding/Branding.tsx
 *
 * Message keys follow the format: formforge.builder.branding.{element}
 *
 * IMPORTANT: All variables must use ICU Message Format syntax
 */
export const brandingMessages = {
  'Add your company branding.': 'formforge.builder.branding.add_branding',
  Logo: 'formforge.builder.branding.logo',
  Bytes: 'formforge.builder.branding.bytes',
  ' {bytes}': 'formforge.builder.branding.bytes_with_space',
  'Submit Button Text': 'formforge.builder.branding.submit_btn_text',
  'Success Message': 'formforge.builder.branding.success_message',
  'Max {value} characters': 'formforge.builder.branding.max_characters',
} as const;

// Export type for type safety
export type BrandingMessageKey = keyof typeof brandingMessages;
